import React from 'react';
import TrendBase from '../components/trend/trendBase';

const Vessel = () => {
  return <TrendBase source='vessel' />;
};

export default Vessel;
